import {
  Hash, Target, Ship, BookMarked, MessageSquare, Calendar, Play, HelpCircle,
  Trophy, Telescope, MapPin, Activity, Compass, Users, Lightbulb, Waves, FolderOpen,
} from 'lucide-react';

/** Destinations de l'app, partagées par la grille de l'accueil et le tiroir mobile « Plus ». */
export const NAV_DESTINATIONS = [
  { icon: Hash, label: 'Channels', path: '/channels', color: 'text-blue-500', tourId: 'nav-channels' },
  { icon: Target, label: 'Defis', path: '/challenges', color: 'text-orange-500', tourId: 'nav-challenges' },
  { icon: Ship, label: 'Mon Odyssee', path: '/progression', color: 'text-cyan-500', showProgress: true },
  { icon: BookMarked, label: 'Mon Carnet', path: '/carnet', color: 'text-amber-600' },
  { icon: MessageSquare, label: 'Messages', path: '/dm', color: 'text-violet-500' },
  { icon: Calendar, label: 'Calendrier', path: '/calendar', color: 'text-red-400', tourId: 'nav-calendar' },
  { icon: Play, label: 'Replays', path: '/replays', color: 'text-red-500', tourId: 'nav-replays' },
  { icon: HelpCircle, label: 'Q&A', path: '/questions', color: 'text-pink-500', tourId: 'nav-questions' },
  { icon: Trophy, label: 'Victoires', path: '/victories', color: 'text-yellow-500', tourId: 'nav-victories' },
  { icon: Telescope, label: 'Vigie Immo', path: '/vigie', color: 'text-emerald-500', tourId: 'nav-vigie' },
  { icon: MapPin, label: 'Carte', path: '/members-map', color: 'text-blue-600' },
  { icon: Activity, label: 'Actualite Communaute', path: '/feed', color: 'text-indigo-500' },
  { icon: Compass, label: 'Objectifs', path: '/objectives', color: 'text-purple-500' },
  { icon: Users, label: 'Ambassadeur', path: '/ambassador', color: 'text-green-500' },
  { icon: Lightbulb, label: 'Idees', path: '/ideas', color: 'text-primary' },
  { icon: Waves, label: 'Saisons', path: '/seasons', color: 'text-blue-400' },
  { icon: FolderOpen, label: 'Ressources', path: '/resources', color: 'text-teal-500' },
];

export default NAV_DESTINATIONS;
